<template>
  <v-row>
    <v-col sm="8" class="pt-0 pb-0">
      <h6 class="mt-4 text-card-gray fz-10 text-card-pay">精算方法{{ index }}</h6>
      <v-autocomplete
        v-model="method"
        :items="realOptions"
        dense
        small
        outlined
        hide-details
        class="v-select-custom mr-3"
        item-text="name"
        item-value="id"
        no-data-text="見つかりませんでした。"
        :disabled="methodDisabled"
        style="width: 300px"
        clearable
      ></v-autocomplete>
    </v-col>
    <v-col sm="4" class="pt-0 pb-0">
      <h6 class="mt-4 text-card-gray fz-10 text-card-pay">金額{{ index }}</h6>
      <v-text-field
        v-model="amount"
        dense
        solo
        hide-details
        class="amount-pay"
        type="number"
        @keypress="isNumber($event)"
        :disabled="amountDisabled"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<script>
export default {
  props: {
    disabled: Boolean,
    options: Array,
    value: Object,
    index: Number,
    otaPointUsed: Boolean,
    canEditOtaPointPaymentAmount: Boolean,
  },
  computed: {
    method: {
      get () {
        return this.value && this.value.method
      },
      set (value) {
        this.$emit('input', { ...this.value, method: value })
      }
    },
    amount: {
      get () {
        return this.value && this.value.amount
      },
      set (value) {
        this.$emit('input', { ...this.value, amount: value })
      }
    },
    methodDisabled () {
      return this.disabled || this.otaPointUsed
    },
    amountDisabled () {
      return this.disabled || (this.otaPointUsed && !this.canEditOtaPointPaymentAmount)
    },
    disallowedMethods () {
      return [
        // TO2020-1645: OTA point payment are allowed.
        // BookingPaymentMethodId.OTAPointJalan,
        // BookingPaymentMethodId.OTAPointIkkyu,
        // BookingPaymentMethodId.OTAPointRakuten,
        // BookingPaymentMethodId.OTAPointRurubu,
        // BookingPaymentMethodId.OTAPointOther,
      ]
    },
    realOptions() {
      return this.options.map(o => {
        return {
          ...o,
          disabled: this.disallowedMethods.includes(o.id),
        }
      })
    }
  },
  methods: {
    isNumber: function (evt) {
      evt = (evt) || window.event
      const charCode = (evt.which) ? evt.which : evt.keyCode
      if ((charCode > 44 && charCode < 58 && charCode !== 47 && charCode !== 46 && charCode !== 45) || (charCode === 13)) {
        return true
      } else {
        evt.preventDefault()
      }
    }
  }
}
</script>
